import { useEffect, useState } from 'react';
import useProduct from 'hooks/useProduct';
import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { ProductUnit } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const useProductFormUnits = (product: Product): ProductUnit[] => {
  const [units, setUnits] = useState<ProductUnit[]>([]);
  const { getMasterListProductUnits, getProductUnits } = useProduct();

  useEffect(() => {
    const { id, custom } = product;
    const loadUnits = custom ? getProductUnits : getMasterListProductUnits;
    loadUnits(id).then(setUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product.id, product.custom]);

  return units;
};
